(function () {
    'use strict';

    angular.module('app.product', ['angular.filter']);
})();